// Full scope per package: docs/packages-spec-sheet.md (sent on the call)
import artAudit from "./assets/ux.webp";
import artSprint from "./assets/ai.webp";
import artBuild from "./assets/web.webp";

export const packages = [
  {
    title: "AI Workflow Audit",
    art: artAudit,
    timeline: "5 days",
    line: "Find out why people stop using your AI tool.",
    deliverables: ["3 to 5 user sessions", "Workflow map", "Trust and control review", "Ranked fix list"],
  },
  {
    title: "Product Sprint",
    art: artSprint,
    timeline: "2 weeks",
    line: "Turn an idea into a prototype your users have tested.",
    deliverables: ["Workflow map and v1 scope", "AI interaction model", "Prototype tested with users", "Go, change or stop call"],
  },
  {
    title: "Product Build",
    art: artBuild,
    timeline: "3–4 weeks",
    line: "Ship a first version your users can log into.",
    deliverables: ["Frontend for your core flows", "Design system in code and Figma", "Staging deployment", "2 weeks of post-launch fixes"],
  },
];
